import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { CheckboxComponent } from '@libs/ui-lib';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { ReviewPlanDialogVM } from './review-plan-dialog.vm';
import { SignBoxComponent } from './sign-box';

@Component({
  selector: 'lib-review-plan-dialog',
  imports: [TranslateModule, ReactiveFormsModule, CheckboxComponent, CurrencyPipe, DatePipe, SignBoxComponent],
  templateUrl: './review-plan-dialog.component.html',
  styleUrl: './review-plan-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReviewPlanDialogComponent {
  public readonly dialogData: ReviewPlanDialogVM = inject(DIALOG_DATA);
  public readonly subTotal = this.dialogData.treatments.reduce((acc, treatment) => acc + treatment.cost, 0);
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  public readonly insuranceEstimate = this.subTotal * 0.4;
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  public readonly discount = this.subTotal * 0.1;
  public readonly total = this.subTotal - this.discount - this.insuranceEstimate;
  public readonly today = new Date();

  public isSigned = false;

  protected readonly consentAcceptedForm = new FormControl(false, { validators: [Validators.requiredTrue] });

  private readonly dialogRef = inject(DialogRef);

  protected onCancelClick(): void {
    this.dialogRef.close(false);
  }

  protected onAcceptClick(): void {
    this.dialogRef.close(true);
  }

  protected onSignChange(isSigned: boolean): void {
    this.isSigned = isSigned;
  }
}
